import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'library_html_containers',
  label: 'Pastas HTML da biblioteca',
  actions: ['list', 'show', 'create'],
  parentName: 'teaching_resources',
  onlyPermission: true,
  hide: true
};

export default generateResources(resource);
